import { KeyboardEvent, useEffect, useState } from "react";

export const useKeyNavigation = <Value>({
  onChange,
  onClose,
  options,
  searchString,
  maxItems,
  increaseMaxItems,
}: {
  onChange: (value: Value) => void;
  onClose: () => void;
  options: { value: Value }[];
  searchString: string;
  maxItems: number;
  increaseMaxItems: () => void;
}) => {
  const [selectedIdx, setSelectedIdx] = useState(-1);

  useEffect(() => {
    setSelectedIdx(-1);
  }, [searchString]);

  const onKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    // arrow up/down button should select next/previous list element
    if (e.code === "ArrowUp") {
      setSelectedIdx((place) => Math.max(0, place - 1));
      e.preventDefault();
    } else if (e.code === "ArrowDown") {
      setSelectedIdx((place) => {
        const newSelectedIdx = Math.min(place + 1, options.length - 1);
        if (newSelectedIdx + 1 >= maxItems) {
          increaseMaxItems();
        }
        return newSelectedIdx;
      });
      e.preventDefault();
    } else if (e.code === "Enter" && selectedIdx >= 0) {
      onChange(options[selectedIdx].value);
      onClose();
      setSelectedIdx(-1);
      e.preventDefault();
    } else if (e.code === "Escape" && searchString) {
      onClose();
      setSelectedIdx(-1);
      e.preventDefault();
    }
  };

  return { selectedIdx, onKeyDown };
};
